import Swiper from 'swiper';
let productsSliderArray = [];

function initProductsSwipe() {
  $('.js-slider-recommend').each(function(index) {
    const $this = $(this);
    const pagination = $this.data('pagination') || null;
    const slides = $this.data('slides') || 4;
    const dskSlides = $this.data('dskslides') || 3;
    const el = $this.parent().find('.swiper-pagination');

    $this.addClass(`sr-${index}`);
    $this.parent().find('.btn-slide--prev').addClass(`prev-${index}`);
    $this.parent().find('.btn-slide--next').addClass(`next-${index}`);

    productsSliderArray.push(
      new Swiper(`.sr-${index}.swiper-container`, {
        slidesPerView: slides,
        spaceBetween: 12,
        autoHeight: true,
        loop: true,
        navigation: {
          nextEl: `.next-${index}`,
          prevEl: `.prev-${index}`
        },
        pagination: {
          el: el,
          type: pagination,
          clickable: true
        },
        breakpoints: {
          767: {
            slidesPerView: 1,
            pagination: {
              type: 'bullets'
            }
          },
          1023: {
            slidesPerView: 2,
            pagination: {
              type: pagination
            }
          },
          1439: {
            slidesPerView: dskSlides,
            pagination: {
              type: pagination
            }
          }
        }
      })
    );
  });
}

if ($('.js-slider-recommend').length) {
  initProductsSwipe();
}

$(window).resize(function() {
  productsSliderArray.forEach(function(element) {
    element.destroy();
  });

  initProductsSwipe();
});
